<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      {{ selected.title }}
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div v-for="(option, i) of options" :key="i" @click="doSelect(option)">
        <span class="custom-select_title">{{ option.title }}</span>
        <span class="custom-select_icon icon" :class="option.icon"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VueSelect",
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    doSelect: function (option) {
      this.open = false;
      this.$emit('changeSelect', option.value);
    }
  },
  computed: {
    selected() {
      return this.default
        ? this.options.filter(option => (option.value == this.default))[0]
        : this.options.length > 0
            ? this.options[0]
            : null
    },
  }
};
</script>

<style scoped>
.custom-select {
  position: relative;
  width: 90%;
  text-align: left;
  outline: none;
  height: 47px;
  line-height: 47px;
  color: #666;
}

.custom-select .selected {
  padding: 15px 10px 15px 1em;
  cursor: pointer;
  user-select: none;
  line-height: normal;
}

.custom-select .selected:after {
  position: absolute;
  top: 15px;
  right: 1em;
  width: 0;
  height: 0;
  content: "\e909";
  font-family: "simbat-icon", sans-serif;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
}

.custom-select .selected.open:after {
  content: "\e92c";
  font-family: "simbat-icon", sans-serif;
}

.custom-select .items {
  -webkit-box-shadow: 0 0 20px rgba(0,0,0,.1);
  box-shadow: 0 0 20px rgba(0,0,0,.1);
  transition: opacity .3s ease 0s;
  border-radius: 10px;
  overflow: hidden;
  position: absolute;
  background-color: #fff;
  left: 0;
  right: 0;
  z-index: 9999;
}

.custom-select .items div {
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div:hover {
  background-color: #009adf;
  color: #fff;
}

.selectHide {
  display: none;
}

.custom-select .custom-select_icon {
  padding: 15px;
  float: right;
}
</style>
